import React from 'react';

const EsriLayerSettingsPlaceholder = () => {
  return (
    <div className="esri-layer-settings">
      <div className="text__placeholder--medium shimmer" />
      {Array.from({ length: 3 }, (_, i) => (
        <div key={`esri-layer-setting${i}`} className="esri-layer-settings__placeholder">
          <div className="square__placeholder shimmer" />
          <div className="square__placeholder shimmer" />
          <div className="text__placeholder--small shimmer" />
        </div>
      ))}
    </div>
  );
};

export default EsriLayerSettingsPlaceholder;
